import React from "react";
import { image } from "@/theme";
import styled from "@emotion/styled";
import { mq } from "@/libs/react-responsive/mediaQuery";
import {
  CommonContainer,
  CommonPageContainer,
} from "@/components/ui/container";

const StyledImage = styled.img(() => ({
  width: "24rem",

  [mq("desktop")]: {
    width: "38rem",
  },
}));

const Text = styled.div(() => ({
  textAlign: "center",
  fontSize: "1.8rem",

  h1: {
    fontSize: "3.2rem",
    marginBottom: "2rem",
  },

  [mq("desktop")]: {
    textAlign: "left",
    fontSize: "2.4rem",

    h1: {
      fontSize: "4.8rem",
      marginBottom: "2rem",
    },
  },
}));

const InnerContainer = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "2rem",

  [mq("desktop")]: {
    flexDirection: "row",
  },
}));

const NotFound = () => {
  return (
    <CommonPageContainer>
      <CommonContainer>
        <InnerContainer>
          <Text>
            <h1>찾을 수 없는 페이지입니다.</h1>

            <p>
              요청하신 페이지는 삭제 또는 변경되었거나, 잘못된 주소입니다. 다른
              페이지로 이동하시거나 주소를 다시 확인해 주세요.
            </p>
          </Text>

          <StyledImage src={image.declarationEstablishment} alt="" />
        </InnerContainer>
      </CommonContainer>
    </CommonPageContainer>
  );
};

export default NotFound;
